import { newDbAccessDefinitions } from "@p0security/integrations-db";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { PostgresComponents } from "./components.ts";

export const PostgresIconUrl =
  "https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg";

/** PostgreSQL's role and SQL accesses are GA, while MySQL's are still in preview */
export const PostgresAccesses = newDbAccessDefinitions("ga");

const PostgresFilters = {
  instance: { keys: ["name"] },
  role: { keys: ["name"] },
} as const satisfies AnyFilterSchema;

export type PostgresFilters = typeof PostgresFilters;

export const PostgresRegistration = Registration({
  accesses: PostgresAccesses,
  category: "resource",
  components: PostgresComponents,
  docs: { install: "postgresql" },
  filters: PostgresFilters,
  itemKind: "instance",
  label: "PostgreSQL",
  logoUrl: PostgresIconUrl,
  maturity: "ga",
  requestType: "requestable",
  useMapping: [{ use: "iam_write", component: "iam-write" }],
});

registerIntegration("postgres", PostgresRegistration);
